var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarquisLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 49,
    viewBox: "0 0 60 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7197 27.2864L21.6819 19.193L30.0391 10.7846L36.708 17.4995L42.2686 12.4387L29.9609 0.0393838L14.9935 15.1234L0 0.0196919V49H60V0L29.7197 27.2864ZM6.206 23.9585V13.8828L11.3103 18.8255L11.5971 19.1143L6.206 24.5361V23.9519V23.9585ZM26.8188 42.2916H20.3911V35.6555H12.8618V42.2916H6.27771V34.0801L16.5515 24.372L26.8253 34.0801V42.2916H26.8188ZM53.7288 42.2916H47.2881V35.6555H39.7588V42.2916H33.1682V34.0801L43.442 24.372L53.7288 34.0801V42.2916ZM53.7288 24.3654L48.3312 18.937L53.7288 13.7056V24.3654Z",
    fill: "#B2934C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarquisLogo);
export default __webpack_public_path__ + "static/media/marquis-logo.112e11aedc6364a5714b6d84236e41f4.svg";
export { ForwardRef as ReactComponent };